
















import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'

@Component
export default class ComponentBackofficeNegativaAutorizacao extends Vue {
  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get negativa() {
    const resposta = this.getBackofficeGlobalStore.solicitacao.roboAutorizacaoMotivoNegativa!
    if (resposta!.startsWith('[')) {
      return { type: 'lista', content: JSON.parse(resposta) }
    }
    return { type: 'texto', content: resposta }
  }
}
